module.exports = __webpack_public_path__ + "static/media/Niveau_elN2_1_527797.423af887.png";